<template>
  <div class="MoreOptions">
    <div class="group">
      <h5 class="label">Date Range</h5>
      <div class="controls">
        <input v-model="localDateFrom" @submit.prevent @keydown.enter.prevent @keydown.delete.prevent="wipeField('from')" type="text" placeholder="YYYY" name="yearfrom" id="yearfrom"/>
        <input v-model="localDateTo" @submit.prevent @keydown.enter.prevent type="text" @keydown.delete.prevent="wipeField('to')" placeholder="YYYY" name="yearto" id="yearto"/>
        <button @submit.prevent @keydown.enter.prevent @click="broadcast('requery')">Apply</button>
      </div>
    </div>
    <div class="group">
      <h5 class="label">Centuries</h5>
      <ul class="controls">
        <li v-for="(item, index) in centuriesCheckItems" :key="'li-' + item.shortname + '-' + index">
          <CheckInput :key="'checkInput-centuries-' + item.shortname + '-' + index" :item="item"/>
        </li>
      </ul>
    </div>
    <div class="group">
      <h5 class="label">Key Person</h5>
      <div class="controls">
        <span class="selectWrap">
          <select name="keyperson" id="keyperson" v-model="activePerson">
            <option value="" selected>Select</option>
            <!-- <option>Martin Luther King Jr.</option>
            <option>Fred L. Shuttleworth</option>
            <option>Eugene &quot;Bull&quot; Conner</option>
            <option>James Bevel</option> -->
            <option v-for="(person, index) in FullKeyPeople" :key="'fkp-' + index" :data-id="person.id">{{ person.name }}</option>
          </select>
        </span>
      </div>
    </div>
    <div class="group">
      <h5 class="label">State</h5>
      <div class="controls">
        <span class="selectWrap">
          <select name="states" id="states" v-model="activeState">
            <option value="" selected>Select</option>
            <option v-for="(state,index) in stateOptions" :key="'state-' + index">{{ state.name }}</option>
          </select>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
var KeyPeople = window.drupalSettings ? window.drupalSettings.searchFilters.key_person : null
import CheckInput from '@/components/CheckInput'
import { mapGetters } from 'vuex'

export default {
  name: 'MoreOptions',
  components: {
    CheckInput
  },
  computed: {
    ...mapGetters({
      activeFilters: 'getActiveFilters',
      dateFilterFrom: 'getDateFilterFrom',
      dateFilterTo: 'getDateFilterTo',
      initial: 'getInitial'
    }),
  },
  mounted: function () {
    if (KeyPeople == null) {
      KeyPeople = this.$parent.backupSettings.key_person
    }
    this.FullKeyPeople = Object.keys(KeyPeople).map((el, index) => {
      return {
        id: el,
        name: KeyPeople[el]
      }
    })

    this.listenFor('initial-key-person', arg => {
      this.activePerson = arg['0']
    })

    this.listenFor('initial-state', arg => {
      // console.log("more options.vue listen for initial state")
      this.activeState = arg['0']
    })

    this.listenFor('initial-filters-date-from', arg => {
      this.localDateFrom = arg
    })

    this.listenFor('initial-filters-date-to', arg => {
      this.localDateTo = arg
    })

    this.listenFor('reset-state-value', arg => {
      this.activeState = ''
    })

    this.listenFor('reset-person-value', arg => {
      this.activePerson = ''
    })

    this.listenFor('reset-date-values', arg => {
      this.localDateFrom = ''
      this.localDateTo = ''
    })
  },
  methods: {
    wipeField: function (which) {
      if (which === 'from') {
        this.localDateFrom = ''
      } else if (which === 'to') {
        this.localDateTo = ''
      }
    }
  },
  watch: {
    localDateFrom: function () {
      this.$store.commit('updateDateFilterFrom', this.localDateFrom + '-01-01T00:00:00-0500')
    },
    localDateTo: function () {
      this.$store.commit('updateDateFilterTo', this.localDateTo + '-12-31T00:00:00-0500')
    },
    activePerson: function () {
      var filters = this.activeFilters

      if (this.activePerson === '') {
        filters.forEach(el => {
          if (el.kind === 'key_person') {
            var index = filters.indexOf(element)
            filters.splice(index, 1)
          }
        })

      } else {

        var pack = {
          name: this.activePerson,
          shortname: "",
          filterId: "",
          kind: "key_person"
        }

        var personFilters = filters.filter(el => {
          return el.kind === "key_person"
        })

        if (personFilters.length === 0) {
          filters.push(pack)
        } else if (personFilters.length === 1) {
          if (this.activePerson === '') {
            // splice
            var index = filters.indexOf(personFilters[0])
            filters.splice(index, 1)
          } else {
            var index = filters.indexOf(personFilters[0])
            filters[index] = pack
          }
        }
      }

      this.$store.commit('updateActiveFilters', filters)

      if (!this.initial) {
        this.broadcast('requery')
      }

    },
    activeState: function () {
      var filters = this.activeFilters

      if (this.activeState === '') {
        filters.forEach(el => {
          if (el.kind === 'states') {
            var index = filters.indexOf(element)
            filters.splice(index, 1)
          }
        })

      } else {
        var pack = {
          name: this.activeState,
          shortname: "",
          filterId: "",
          kind: "states"
        }

        var stateFilters = filters.filter(el => {
          return el.kind === "states"
        })

        if (stateFilters.length === 0) {
          filters.push(pack)
        } else if (stateFilters.length === 1) {
          if (this.activeState === '') {
            var index = filters.indexOf(stateFilters[0])
            filters.splice(index, 1)
          } else {
            var index = filters.indexOf(stateFilters[0])
            filters[index] = pack
          }
        }

      }

      this.$store.commit('updateActiveFilters', filters)
      if (!this.initial) {
        this.broadcast('requery')
      }
    }
  },
  data () {
    return {
      FullKeyPeople: null,
      activePerson: "",
      activeState: "",
      localDateFrom: '',
      localDateTo: '',
      centuriesCheckItems: [
        {
          name: "1500s",
          shortname: "1500s",
          resultsCount: "6",
          filterId: 0,
          kind: "centuries"
        },
        {
          name: "1600s",
          shortname: "1600s",
          resultsCount: "5",
          filterId: 0,
          kind: "centuries"
        },
        {
          name: "1700s",
          shortname: "1700s",
          resultsCount: "12",
          filterId: 0,
          kind: "centuries"
        },
        {
          name: "1800s",
          shortname: "1800s",
          resultsCount: "2",
          filterId: 0,
          kind: "centuries"
        },
        {
          name: "1900s",
          shortname: "1900s",
          resultsCount: "37",
          filterId: 0,
          kind: "centuries"
        },
        {
          name: "2000s",
          shortname: "2000s",
          resultsCount: "17",
          filterId: 0,
          kind: "centuries"
        }
      ],
      stateOptions: [
        { name: "Alabama", value: "Alabama" },
        { name: "Alaska", value: "Alaska" },
        { name: "American Samoa", value: "American Samoa" },
        { name: "Arizona", value: "Arizona" },
        { name: "Arkansas", value: "Arkansas" },
        { name: "California", value: "California" },
        { name: "Colorado", value: "Colorado" },
        { name: "Connecticut", value: "Connecticut" },
        { name: "Delaware", value: "Delaware" },
        { name: "District of Columbia", value: "District of Columbia" },
        { name: "Florida", value: "Florida" },
        { name: "Georgia", value: "Georgia" },
        { name: "Guam", value: "Guam" },
        { name: "Hawaii", value: "Hawaii" },
        { name: "Idaho", value: "Idaho" },
        { name: "Illinois", value: "Illinois" },
        { name: "Indiana", value: "Indiana" },
        { name: "Iowa", value: "Iowa" },
        { name: "Kansas", value: "Kansas" },
        { name: "Kentucky", value: "Kentucky" },
        { name: "Louisiana", value: "Louisiana" },
        { name: "Maine", value: "Maine" },
        { name: "Marshall Islands", value: "Marshall Islands" },
        { name: "Maryland", value: "Maryland" },
        { name: "Massachusetts", value: "Massachusetts" },
        { name: "Michigan", value: "Michigan" },
        { name: "Micronesia", value: "Micronesia" },
        { name: "Minnesota", value: "Minnesota" },
        { name: "Mississippi", value: "Mississippi" },
        { name: "Missouri", value: "Missouri" },
        { name: "Montana", value: "Montana" },
        { name: "Nebraska", value: "Nebraska" },
        { name: "Nevada", value: "Nevada" },
        { name: "New Hampshire", value: "New Hampshire" },
        { name: "New Jersey", value: "New Jersey" },
        { name: "New Mexico", value: "New Mexico" },
        { name: "New York", value: "New York" },
        { name: "North Carolina", value: "North Carolina" },
        { name: "North Dakota", value: "North Dakota" },
        { name: "Northern Mariana Islands", value: "Northern Mariana Islands" },
        { name: "Ohio", value: "Ohio" },
        { name: "Oklahoma", value: "Oklahoma" },
        { name: "Oregon", value: "Oregon" },
        { name: "Pennsylvania", value: "Pennsylvania" },
        { name: "Puerto Rico", value: "Puerto Rico" },
        { name: "Rhode Island", value: "Rhode Island" },
        { name: "South Carolina", value: "South Carolina" },
        { name: "South Dakota", value: "South Dakota" },
        { name: "Tennessee", value: "Tennessee" },
        { name: "Texas", value: "Texas" },
        { name: "United States Virgin Islands", value: "United States Virgin Islands" },
        { name: "Utah", value: "Utah" },
        { name: "Vermont", value: "Vermont" },
        { name: "Virginia", value: "Virginia" },
        { name: "Washington", value: "Washington" },
        { name: "West Virginia", value: "West Virginia" },
        { name: "Wisconsin", value: "Wisconsin" },
        { name: "Wyoming", value: "Wyoming" },
      ]
    }
  },
};
</script>

<style scoped lang="scss">
  .MoreOptions {
    padding-top: 30px;

    .controls {
      li {
        width: 100% !important; // the deep magic is too strong!
      }
    }
  }
</style>
